import React, { PureComponent } from 'react';

import { Loading } from 'components/cosmos';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './FileProcessing.scss';

export default class FileProcessing extends PureComponent {
  static propTypes = {
    label: PropTypes.string
  };

  render() {
    const { label } = this.props;

    return (
      <div className="file--processing">
        <div className="file__processing__content">
          <Loading center />
          <p className="secondary">
            <I18n label={label} />
          </p>
        </div>
      </div>
    );
  }
}
